import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import {ReportsService} from '../../../report/reports/reports.service';
import {Customer} from '../../../customer/customer.model';
import {CallCenter} from '../../../call-center/call-center.model';
import {Agency} from '../../../agency/agency.model';
import {Organization} from '../../../organization/organization.model';
import {UserPartner} from '../../../users/users-partner/user-partner.model';
import {UserClk} from '../../../users/users-clk/user-clk.model';
import {CustomValidators} from '../../validators/custom.validators';
import {PlatformConfig} from '../../../app-loader/platform-config';
import {ConfigLoaderService} from '../../../app-loader/config-loader.service';
import { UserCollect } from '../../../users/users-collector/user-collector.model';
import { FormApiValidationService } from '../../forms/form-api-validation.service';
@Component({
  selector: 'app-report-form',
  templateUrl: './report-form.component.html',
  styleUrls: ['./report-form.component.scss']
})
export class ReportFormComponent implements OnInit {

  @Input('customer') customer: Customer;
  @Input('userCollect') userCollect: UserCollect;
  @Input('callCenter') callCenter: CallCenter;
  @Input('agency') agency: Agency;
  @Input('organization') organization: Organization;
  @Input('userOperatorPartner') userOperatorPartner: UserPartner;
  @Input('userOperatorClk') userOperatorClk: UserClk;

  form: FormGroup;
  reportsParameters: any = null;
  loading: boolean = false;
  showBtnLoading: boolean = false;
  currentDate = new Date();
  maxDate = new Date().toISOString();
  minDate;
  groupsBy =  [
    { 'field': 'operationDate', 'value': 'operationDate' },
    { 'field': 'ORGANIZATION', 'value': 'organization' },
    { 'field': 'CALL CENTER', 'value': 'callCenter' },
    { 'field': 'AGENCY', 'value': 'agency' },
    { 'field': 'OPERATION TYPE', 'value': 'operationType' },
    { 'field': 'ACCOUNT', 'value': 'account' },
    { 'field': 'userOperatorClk', 'value': 'userOperatorClk' },
    { 'field': 'userOperatorPartner', 'value': 'userOperatorPartner' },
  ];

  operationTypes =  [
    { 'field': 'CREDIT', 'value': 'CREDIT' },
    { 'field': 'DEBIT', 'value': 'DEBIT' },
    { 'field': 'TRANSFERT', 'value': 'TRANSFERT' },
  //  { 'field': 'DEPOT_COLLECT', 'value': 'DEPOT_COLLECT' },
  //  { 'field': 'TRANSFERT_COLLECT', 'value': 'TRANSFERT_COLLECT' },
    { 'field': 'CASHOUT', 'value': 'CASHOUT' }
  ];
  status = [{'field': 'CONFIRMED', 'value': 'CONFIRMED'},{'field':'ONGOING','value':'ONGOING'}]
  platformConfig: PlatformConfig;

  constructor(private fb: FormBuilder,
              private reportsService: ReportsService,
              private router: Router,
              public configLoaderService: ConfigLoaderService,
              private formApiValidation: FormApiValidationService) {
    this.platformConfig = this.configLoaderService.getPlatformConfig();
  }

  ngOnInit() {
    var d = new Date();
    d.setMonth(d.getMonth() - 3); // rapport au delà de 3 mois
    this.minDate = d.toISOString();
    this.reportsParameters = this.reportsService.reportParameters;
    this.form = this.fb.group ( {
      groupBy: [null ,
        Validators.compose ( []),
        Validators.composeAsync([])
      ],
      fields: this.fb.group({
        operationDate: this.fb.group({
          value: [this.currentDate ,
            Validators.compose ( [Validators.required]),
            Validators.composeAsync([])
          ],
          value2: [this.currentDate ,
            Validators.compose ( [Validators.required]),
            Validators.composeAsync([])
          ],
        }),
        amount: this.fb.group({
          lowerValue: [null,
            Validators.compose ( [Validators.min(0)]),
            Validators.composeAsync([])
          ],
          upperValue: [null,
            Validators.compose ( []),
            Validators.composeAsync([])
          ],
        }),
        account: [null ,
          Validators.compose ( []),
          Validators.composeAsync([])
        ],

        operationType: [null ,
          Validators.compose ( []),
          Validators.composeAsync([])
        ],
        status: [null ,
          Validators.compose ( []),
          Validators.composeAsync([])
        ],
        organization: [null ,
          Validators.compose ( [CustomValidators.linkedEntity]),
          Validators.composeAsync([])
        ],

        agency: [null ,
          Validators.compose ( [CustomValidators.linkedEntity]),
          Validators.composeAsync([])
        ],

        callCenter: [null ,
          Validators.compose ( [CustomValidators.linkedEntity]),
          Validators.composeAsync([])
        ],

        userOperatorPartner: [null ,
          Validators.compose ( [CustomValidators.linkedEntity]),
          Validators.composeAsync([])
        ],

        userOperatorClk: [null ,
          Validators.compose ( [CustomValidators.linkedEntity]),
          Validators.composeAsync([])
        ]

      }),
    });

    if (this.reportsParameters !== null && this.reportsParameters !== undefined) {
      this.form.patchValue(this.reportsParameters);
    }

    if (this.customer !== null && this.customer !== undefined) {
      this.operationTypes = this.operationTypes.filter(
        (op) => {
          return op.value === 'CREDIT' || op.value === 'DEBIT' || op.value === 'TRANSFERT' || op.value === 'TRANSFERT_COLLECT';
        }
      );
      (<FormGroup>this.form.controls['fields']).controls['account'].setValue(this.customer.account);
    }
    if (this.userCollect !== null && this.userCollect !== undefined) {
      this.operationTypes = this.operationTypes.filter(
        (op) => {
          return op.value === 'DEPOT_COLLECT' || op.value === 'TRANSFERT_COLLECT' || op.value === 'COLLECT_CASHOUT' || op.value === 'TRANSFERT';
        }
      );
      (<FormGroup>this.form.controls['fields']).controls['account'].setValue(this.userCollect.account);
    }
    if (this.callCenter !== null && this.callCenter !== undefined) {
      (<FormGroup>this.form.controls['fields']).controls['callCenter'].setValue(this.callCenter);
    }
    if (this.agency !== null && this.agency !== undefined) {
      (<FormGroup>this.form.controls['fields']).controls['agency'].setValue(this.agency);
    }
    if (this.organization !== null && this.organization !== undefined) {
      (<FormGroup>this.form.controls['fields']).controls['organization'].setValue(this.organization);
    }
    if (this.userOperatorPartner !== null && this.userOperatorPartner !== undefined) {
      (<FormGroup>this.form.controls['fields']).controls['userOperatorPartner'].setValue(this.userOperatorPartner);
    }
    if (this.userOperatorClk !== null && this.userOperatorClk !== undefined) {
      (<FormGroup>this.form.controls['fields']).controls['userOperatorClk'].setValue(this.userOperatorClk);
    }

  }

  onSubmit() {
    if (!this.form.valid) {
      this.formApiValidation.touchAllFormControls(this.form);
      return;
    }
    this.loading = true;
    const requestParameters = this.form.value;
    
    this.reportsService.getReport(requestParameters).subscribe(
      (response) => {
        this.reportsService.reportsSack = response;
        this.router.navigate(['/reports', 'operations',  'show']);
      }
    );
  }

  compareWithFn(item1, item2) {
    return item1 && item2 ? item1.value === item2.value : item1 === item2;
  }

  onOrganizationSelected(e) {
    (<FormGroup>this.form.controls['fields']).controls['agency'].setValue(null);
    (<FormGroup>this.form.controls['fields']).controls['organization'].setValue(e);
  }

  onAgencySelected(e) {
    (<FormGroup>this.form.controls['fields']).controls['agency'].setValue(e);
    (<FormGroup>this.form.controls['fields']).controls['organization'].setValue(e.organization);
  }

  onCallCenterSelected(e) {
    (<FormGroup>this.form.controls['fields']).controls['callCenter'].setValue(e);
  }

  onUserOperatorPartnerSelected(e) {
    (<FormGroup>this.form.controls['fields']).controls['userOperatorPartner'].setValue(e);
  }

  onUserOperatorClkSelected(e) {
    (<FormGroup>this.form.controls['fields']).controls['userOperatorClk'].setValue(e);
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/report-form/report-form.component.ts